const currentState = {
    companyLanguages: {
        languages: null,
    },
    systemLanguages: {
        languages: null,
    },
    activeLanguage:{
        language: null
    }
}

const reducer = (state = currentState, action) => {
    switch (action.type) {
        case 'SET_SYSTEM_LANGUAGES': {
            return{
                ...state,
                systemLanguages: {
                    languages: action.payload
                }
            }
        }
        case 'SET_COMPANY_LANGUAGES': {
            return{
                ...state,
                companyLanguages: {
                    languages: action.payload
                }
            }
        }
        case 'ADD_COMPANY_LANGUAGE': {
            return{
                ...state,
                companyLanguages: {
                    languages: action.payload
                }
            }
        }
        case 'SET_ACTIVE_LANGUAGES':{
            return{
                ...state,
                activeLanguage: action.payload
            }
        }
        case 'DELETE_COMPANY_LANGUAGES':{
            return{
                ...state,
                companyLanguages: {
                    languages: action.payload
                }
            }
        }
        default:
            return state;
    }
}

export default reducer;